import axios from "axios";

// Ronda 28: usar window.location.origin siempre que sea posible para que el
// frontend no dependa del REACT_APP_BACKEND_URL configurado en el build.
// El env var se mantiene solo como fallback (SSR / tests donde no hay window).
const BACKEND_URL = (typeof window !== "undefined" && window.location && window.location.origin)
  ? window.location.origin
  : process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// The auth token is stored as an httpOnly Secure cookie (`bea_admin_session`)
// set by the backend on /admin/login. We use `withCredentials: true` so the
// browser sends the cookie automatically on every request to `${API}`.
// The token NEVER touches JavaScript / localStorage — safe from XSS token theft.
// Ronda 33.15 · Timeout explícito para todas las peticiones. Antes axios
// no tenía timeout y una petición colgada dejaba a la UI en «Cargando…»
// indefinidamente. 25 s cubre incluso una respuesta lenta del LLM sin
// llegar al 30 s con el que algunos proxies matan la conexión.
export const REQUEST_TIMEOUT_MS = 25000;
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  timeout: REQUEST_TIMEOUT_MS,
});

// Ronda 31.2 · Mobile-safari agressive HTTP cache workaround.
// iOS Safari (and some Android WebViews) cache GET responses aggressively
// when there is no `Cache-Control: no-store` header even between page
// refreshes. This caused the /admin/bookings response to stay stale on
// mobile for minutes while desktop refreshed correctly. We add a `_t=<ms>`
// query param to every admin/waitlist GET so the URL is unique and cannot
// be served from cache regardless of proxy or browser behaviour.
api.interceptors.request.use((config) => {
  const method = (config.method || "get").toLowerCase();
  const url = config.url || "";
  const isAdmin = url.startsWith("/admin") || url.startsWith("/receipt");
  if (method === "get" && isAdmin) {
    config.params = { ...(config.params || {}), _t: Date.now() };
  }
  return config;
});

// Global 401 handler for admin routes: notify listeners so the panel can
// force a fresh login. We can no longer clear the cookie from JS (it's
// httpOnly), but the backend rejects invalid tokens anyway.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const url = err?.config?.url || "";
    if (err?.response?.status === 401 && (url.startsWith("/admin") || url.startsWith("/receipt"))) {
      // Notify listeners so the panel can force a fresh login. `window` may
      // be undefined in SSR/tests — we swallow that specific case silently.
      try {
        window.dispatchEvent(new CustomEvent("bea:admin-unauthenticated"));
      } catch (dispatchErr) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.debug("SSR skip: window.dispatchEvent unavailable", dispatchErr);
      }
    }
    return Promise.reject(err);
  }
);

export function normalizePhone(raw) {
  const digits = (raw || "").replace(/\D/g, "");
  let d = digits;
  if (d.startsWith("0034")) d = d.slice(4);
  else if (d.startsWith("34") && d.length === 11) d = d.slice(2);
  return d.length === 9 ? `+34${d}` : null;
}

export function formatSpanishDate(iso) {
  const d = new Date(iso);
  return d.toLocaleDateString("es-ES", { weekday: "long", day: "numeric", month: "long", timeZone: "Europe/Madrid" });
}

export function formatTime(iso) {
  const d = new Date(iso);
  return d.toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit", timeZone: "Europe/Madrid" });
}
